const GRAPH_SCALES = {
  halfAnHour: '30 minutes',
  hour: '1 hour',
  day: 'Day',
  week: 'Week',
  month: 'Month',
};

export default GRAPH_SCALES;
